export default __webpack_public_path__ + "static/media/enhancedWebsiteHero.968aa5aa.jpg";